import React from 'react';
import {
    Accordion,
    AccordionSummary,
    Checkbox,
    FormControlLabel,
    Typography
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { headers } from './headers';
import { stylesGenContract } from './stylesGenContract';

const SeeVacancies = ({
    data,
    valVacancy,
    handleChangeCheckedVacancy
}) => {
    const classes = stylesGenContract();

    const getValueByKey = (object, header) => {
        if (header.child === null) {
            if(header.field === 'nameEmployee'){
                const person = `${data?.person?.firstName} ${data?.person?.secondName ?? ''} ${data?.person?.surname} ${data?.person?.secondSurname ?? ''}`
                return person;
            }
            if(header.field === 'regional'){
                const regional = data?.vacant?.requisition.regional.name;
                return regional;
            }
            if(header.field === 'chargeRequested'){
                const charge = data?.vacant?.requisition.chargeRequested.denomination;
                return charge;
            }
          if (header.field) {
            let result = "";
            if (header.field.includes(",")) {
              header.field.split(/\s*,\s*/).forEach(function (myString) {
                result += object[myString] + " ";
              });
              return result;
            }
            return object[header.field];
          }
          return "";
        }
        return object[header.field] !== null
          ? object[header.field][header.child]
          : "";
    };
    
    const FlippedOrderExpansionPanelSummary = withStyles({
        root: {
            flexDirection: "row-reverse",
        },
    })(AccordionSummary);
        FlippedOrderExpansionPanelSummary.defaultProps = {
        IconButtonProps: { edge: "start" },
    };

  return (
    <div style={{marginTop: '10px'}}>
        <Accordion
                style={{borderLeftStyle: "solid", borderLeftColor: '#F8DF13', pointerEvents: "none"}}
            >
                <FlippedOrderExpansionPanelSummary aria-controls="panel1c-content">

                {headers.initialHeaders.map((header) => (
                    <div className={classes.column}>
                    <Typography className={classes.heading}>
                        {header?.title}
                    </Typography>
                    <Typography className={classes.secondaryHeading}style={{flexBasis: 'auto', wordBreak: 'normal'}}>
                        {getValueByKey(data, header) }
                    </Typography>
                    </div>
                ))}
                <div className={classes.columnEvent}>
                    <FormControlLabel 
                        control={
                            <Checkbox 
                                color="primary" 
                                name="checkBox"
                                //checked={valVacancy} 
                                value={data?.id}
                                onChange={(e) => handleChangeCheckedVacancy(e,data)}
                                onClick={(e) => e.stopPropagation()}
                            />
                        }
                    />                    
                </div>
                </FlippedOrderExpansionPanelSummary>
            </Accordion>
    </div>
  )
}

export default SeeVacancies